import { gql } from '@apollo/client'

export const LABELING_EXPLORER = gql`
  query LabelingExplorer(
    $input: LabelingExplorerInput!
    $includeImageBoxes: Boolean! = true
  ) {
    labelingExplorer(input: $input) {
      items {
        cursor
        image {
          id
          imageUrl
          bucketPath
          imageSource
          sourceCustomer
          created
          acquisitionScore
          focusScore
          detectionEntropyScore
          recencyScore
          unidentifiedCount
          boxCount
          closeConfidenceCount
          verifiedBoxCount
          unverifiedBoxCount
          boundingBoxes @include(if: $includeImageBoxes) {
            id
            minX
            maxX
            minY
            maxY
            metaClass
            detectionConfidence
            isHumanAdded
            isHumanDeleted
            verifiedUpc
            upcVerifiedAt
            isVerified
            currentUpc
            classifierScoreMargin
            acquisitionScore
            focusScore
            pixelArea
            isUnidentified
            predictedUpcs {
              upc
              classifierScore
              classifierRank
              displayIndex
              isFieldLabeled
            }
          }
        }
        box {
          id
          minX
          maxX
          minY
          maxY
          metaClass
          detectionConfidence
          isHumanAdded
          isHumanDeleted
          verifiedUpc
          upcVerifiedAt
          isVerified
          currentUpc
          classifierScoreMargin
          acquisitionScore
          focusScore
          pixelArea
          isUnidentified
          predictedUpcs {
            upc
            classifierScore
            classifierRank
            displayIndex
            isFieldLabeled
          }
        }
      }
      pageInfo {
        hasNextPage
        nextCursor
      }
      totalCount
    }
  }
`
